import styled from "styled-components";

const triangle = `
  width: 0; 
  height: 0; 
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid black;
`;

export const MainHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  background-color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  font-size: 14px;
  z-index: 2;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;

  > a {
    display: flex;
    padding-left: 20px;
  }
`;

export const Logo = styled.div`
  display: flex;
  padding-left: 25px;
  width: 130px;
  height: 100%;
  cursor: pointer;

  img {
    width: 100px;
  }
`;

export const NavRef = styled.div`
  padding: 0 45px 0 15px;
  font-weight: 500;
  > span {
    padding: 0 12px 0 10px;
  }
`;

export const LeaveEditorButton = styled.div`
  cursor: pointer;
  align-items: center;
  img {
    margin-right: 8px;
  }
`;

export const HeaderCenter = styled.div`
  display: flex;
  margin-left: auto;
`;

export const HeaderRight = styled.div`
  display: flex;
  margin-left: auto;
`;

export const MenuItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaeaea;
  color: #383838;

  &:not(:last-child) {
    padding: 0 20px;
  }

  /* &:last-child{
    button{
      padding: 16px 35px 18px;
      border: none; 
      cursor: pointer;      
      &:first-child{
        color: #4B4B4B;
      }
      &:last-child{
        background-color: #45AE70;
        color: #fff;
      }
    }
  } */
`;

export const IconItem = styled.button`
  width: 35px;
  height: calc(100% - 4px);
  padding: 0;
  border: none;
  border-bottom: 3px solid #737373;
  background-color: transparent;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 5px;
  }
`;

export const Button = styled.button`
  padding: 20px 35px;
  background-color: transparent;
  border: none;
`;

export const PageStatusContent = styled(MenuItem)`
  width: 145px;
  cursor: pointer;

  &:hover {
    background-color: rgb(243, 243, 243);
  }

  ${props => props.show && "background-color: rgb(243, 243, 243);"};

  &:before {
    content: "";
    display: block;
    width: 13px;
    height: 13px;
    background-color: ${props =>
      props.status === "publish" ? "#3bd078" : "#FF5252"};
    margin-right: 15px;
    border-radius: 50%;
  }
  > div {
    &:nth-child(1) {
      display: flex;
      align-items: center;
      &:after {
        content: "";
        display: block;
        ${triangle};
        margin-left: 15px;
      }
    }
    &:nth-child(2) {
      top: 100%;
      right: 15px;
      margin-top: 10px;
      box-shadow: rgba(0, 0, 0, 0.15) 2px 2px 6px;
    }
  }
`;

export const PageSelectContent = styled(MenuItem)`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${props => props.show && "background-color: rgb(243, 243, 243);"};

  &:hover {
    background-color: rgb(243, 243, 243);
  }

  span {
    margin-right: 10px;
    font-weight: 500;
  }
  > div {
    &:nth-child(2) {
      display: flex;
      align-items: center;
      justify-content: center;
      &:after {
        content: "";
        display: block;
        ${triangle};
        margin-left: 15px;
      }
    }
    &:nth-child(3) {
      top: 100%;
      right: 14px;
      margin-top: 10px;
      box-shadow: rgba(0, 0, 0, 0.15) 2px 2px 6px;
    }
  }
`;

export const PageName = styled.p`
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PageSettingsContent = styled(MenuItem)`
  cursor: pointer;
  &:hover {
    background-color: rgb(243, 243, 243);
  }
  img {
    margin-right: 10px;
  }
`;

export const ButtonContainer = styled(MenuItem)`
  > button {
    font-size: 14px;
    color: #ffffff;

    &:nth-child(1) {
      color: #000000;
      background-color: transparent;
      margin-left: 20px;
    }

    &:nth-child(2) {
      margin: 0 20px;
    }

    &:nth-child(3) {
      background: linear-gradient(197.56deg, #fa709a -4.89%, #fc988d 104.75%);
      border-radius: 0;
      height: 100%;

      > svg {
        margin-right: 5px;
      }
    }
  }
`;

export const HistoryContainer = styled(MenuItem)`
  > img {
    margin: 0 7.5px;
  }
`;

export const StatusContainer = styled(MenuItem)`
  border: none;
  font-size: 12px;
  margin-left: 20px;
  min-width: 230px;
  text-align: left;
  justify-content: flex-start;
  color: #4f4f4f;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const LoadingContainer = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 145px;
`;

export const ModalContent = styled.div`
  padding: 0 30px;
`;

export const LabelPageCreate = styled.label`
  font-size: 16px;
  line-height: 19px;
  margin-top: 40px;
  display: inline-block;
`;

export const InputPageNameCreate = styled.input`
  padding: 15px 10px;
  width: 80%;
  border-radius: 1px;
  border: 1px solid #c9c9c9;
  margin-top: 15px;
  outline: none;
  margin-bottom: 100px;
`;

export const ButtonCreate = styled.button`
  display: flex;
  justify-content: center;
  margin-left: 8px;
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: flex-end;

  > button {
    &:nth-child(2) {
      display: flex;
      justify-content: center;
      margin-left: 8px;

      > svg circle {
        stroke: #fff;
      }
    }
  }
`;

export const TooltipWrapper = styled.div`
  padding: 10px 0 0 0;
  margin: 0;
  position: absolute;
  top: 45px;
  right: 2px;
  visibility: ${props => (props.off ? "hidden !important" : "hidden")};

  &:hover {
    visibility: visible;
  }
`;
export const Tooltip = styled.div`
  border-radius: 3px;
  width: 220px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 6px;
  padding: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #212121;
  display: block;
  text-align: left;

  &:before {
    top: 4px;
    right: 10px;
    z-index: 2;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 6px solid #fff;
    content: "";
    position: absolute;
    display: block;
    width: 0;
    height: 0;
  }
  span {
    margin-top: 10px;
    line-height: 1.1;
    font-size: 12px;
    display: block;
    color: #515151;
  }

  a {
    display: block;
    font-size: 13px;
    margin-top: 8px;
    color: #44adf8;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &:focus {
    outline: none;
  }
`;

export const EditorTitle = styled.div`
  color: #212121;
  margin-left: 5px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 10px;
  border-left: 2px solid #5f5f5f;
`;

export const ButtonWrapperTooltip = styled.div`
  display: flex;
  position: relative;
  padding: 0;
  margin: 0;
  height: 100%;

  > button {
    align-self: center;
  }

  &:last-of-type {
    margin-right: 20px;
  }

  &:hover {
    ${TooltipWrapper} {
      visibility: ${props => (props.off ? "hidden" : "visible")};
    }
  }
`;

export const AnimatedCheck = styled.div`
  position: absolute;
  left: -24px;

  svg {
    display: block;
    fill: none; 
    width: 24px;
    height: 24px;
    stroke-width: 2.3;
    stroke: var(--tick-stroke);
    polyline {
      stroke-dasharray: 18 18 18;
      stroke-dashoffset: var(--tick-offset, 18);
      transition: stroke-dashoffset 0.8s ease;
    }
  }

  ${props => props.success && `
    --tick-stroke: #ffffff;
    --tick-offset: 36;
  `}
`